module.exports = __webpack_public_path__ + "static/sport/h5out4.4b804b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5out4.png
// module id = OrEW
// module chunks = 0